
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"45","height":"45"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.25 35.625a3.761 3.761 0 0 0 3.75 3.75h15a3.761 3.761 0 0 0 3.75-3.75v-22.5h-22.5zM35.625 7.5h-6.563l-1.874-1.875h-9.375L15.937 7.5H9.375v3.75h26.25z"}}),_c('path',{attrs:{"d":"M0 0h45v45H0z","fill":"none"}})])
          )
        }
      }
    